import React from "react";

import "./Forms.scss";
// add .error to component for error state.

const TextArea = (props) => {
  const {
    rows = "4",
    cols = "120",
    classes = "",
    autoComplete = "on",
    iserror,
    labelerror,
    ...restProps
  } = props;
  return (
    <div className={`form-wrapper ${classes}`}>
      <textarea id={props.id} {...restProps} rows={rows} cols={cols}></textarea>
      {iserror && <div style={{ color: "red" }}>{labelerror}</div>}
    </div>
  );
};
export default TextArea;
